import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const DownloadIcon = ({
  width = 24,
  height = 24,
  stroke = '#E8E8E8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M21 15v4c0 .53-.21 1.04-.586 1.414C20.04 20.79 19.53 21 19 21H5c-.53 0-1.04-.21-1.414-.586C3.21 20.04 3 19.53 3 19v-4M7 10l5 5 5-5M12 15V3"
    />
  </svg>
);
